import React from 'react'

export default function HemlaneEmbed() {
    return (
        <>
            <iframe
                id='hemlane-owner-listings-embed-frame'
                style={{margin:0, padding:0, border:0, overflow:'hidden' }}
                width="100%"
                src={`https://www.hemlane.com/listings/owners/5f44e30f-48f0-413e-aed7-73bdabf67cff?embed=true&title=Available%20Properties`}
                title="Hemlane Owner Listing"
                onLoad= {() => {
                    var el = document.getElementById('hemlane-owner-listings-embed-frame');
                    if (el) {
                    window.addEventListener('message', function(e) {
                    if (console && console.log) { console.log(e); }
                    var possibleHeight = parseInt(e.data, 10);
                    if (!isNaN(possibleHeight)) {
                        console.log(possibleHeight);
                        if (e.origin === 'https://www.hemlane.com') {
                            document.getElementById(
                            'hemlane-owner-listings-embed-frame'
                            ).height = possibleHeight;
                        }
                    }
                });
                    el.contentWindow.postMessage('get_hemlane_listing_page_height', '*');                
                }
            }}
            />
        </>
    )
}


/*
<script>
    var i = document.createElement('iframe');
    i.id = 'hemlane-owner-listings-embed-frame';
    i.width = '100%';
    i.scrolling = 'no';
    i.src =
      'https://www.hemlane.com/listings/owners/ long string of letters and numbers}?embed=true&title=Available%20Properties';
    i.style = 'margin:0;padding:0;border:0;overflow:hidden;';
    i.onload = function() {
      var el = document.getElementById('hemlane-owner-listings-embed-frame');
      if (el) {
        window.addEventListener('message', function(e) {
          if (console && console.log) { console.log(e); }
          var possibleHeight = parseInt(e.data, 10);
          if (!isNaN(possibleHeight)) {
            if (e.origin === 'https://www.hemlane.com') {
              document.getElementById(
                'hemlane-owner-listings-embed-frame'
              ).height = possibleHeight;
            }
          }
        });
        el.contentWindow.postMessage('get_hemlane_listing_page_height', '*');
      }
    };
    document.getElementById('hemlane-listings-embed-container').appendChild(i);
</script>
* */